import { useState, useRef } from 'react';
import { useIsomorphicLayoutEffect } from '@lib/hooks'

export const usePostComments = ({
  commentCount: defaultCommentCount,
  id
}) => {
  const [commentCount, setCommentCount] = useState(defaultCommentCount)
  const commentInputRef = useRef(null);
  useIsomorphicLayoutEffect(() => {
    setCommentCount(defaultCommentCount)
  }, [id, defaultCommentCount])
  return {
    commentCount,
    setCommentCount,
    commentInputRef
  }
}
